"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _OvhCloudPlugin = /*#__PURE__*/ _interop_require_default(require("./OvhCloudPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _OvhCloudPlugin.default,
    id: 'ovh',
    title: 'Ovh',
    recoveryTitle: 'OvhCloud Object Storage',
    version: '0.0.4',
    logo: 'plugins/ovhCloud.png',
    tags: 'Storage',
    description: 'Upload your files to a space that you can access via HTTPS using the OpenStack Swift API, or the S3 API. ',
    inputs: {
        title: 'Configure OvhCloud Object Storage',
        items: [
            {
                key: 'bucket',
                label: 'Bucket Name',
                placeholder: 'Bucket Name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'region',
                label: 'Region',
                placeholder: 'Region',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_key',
                label: 'Access Key',
                placeholder: 'Access Key',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_secret',
                label: 'Access Secret',
                placeholder: 'Access Secret',
                type: _nocodbsdk.XcType.Password,
                required: true
            },
            {
                key: 'acl',
                label: 'Access Control Lists (ACL)',
                placeholder: 'Default set to public-read',
                type: _nocodbsdk.XcType.SingleLineText,
                required: false
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully configured! Attachments will now be stored in OvhCloud Object Storage.',
        msgOnUninstall: ''
    },
    category: 'Storage'
};
const _default = config;
